export const dataHelper = {
	extractData,
}

function extractData(documentContent, setContent, conceptDocs, idDocument) {
	try {
		const opcionesCampos = [
			"subject",
			"to",
			"from",
			"page_number",
			"total_page_number",
			"author",
			"file_name",
			"filepath",
			"filename",
			"category",
			"comments",
			"content_status",
			,
			"identifier",
			"keywords",
			"language",
			"title",
			"version",
		]
		if (documentContent) {
			let contentDoc = documentContent
			// let datosGenerales=conceptDocs.data.filter(i => i['_id']['$oid']===idDocument);
			let datosGenerales = conceptDocs.data.filter((i) => i["id"] === idDocument)
			let subject = ""
			let to = ""
			let from = ""
			let page_number = ""
			let total_page_number = ""
			let author = ""
			let filename = ""
			let file_name = ""
			let filepath = ""
			let category = ""
			let comments = ""
			let content_status = ""
			let identifier = ""
			let keywords = ""
			let language = ""
			let title = ""
			let version = ""
			if (datosGenerales.length > 0) {
				opcionesCampos.forEach(function (index) {
					if (datosGenerales[0].hasOwnProperty(index)) {
						eval(index + "=" + "`${datosGenerales[0][index]}`")
					}
				})
			}

			setContent({
				documentId: idDocument,
				documentText: documentContent,
				documentSubject: subject, //contentDoc.data[0].subject,
				documentFrom: from, //contentDoc.data[0].from,
				documentTo: to, //contentDoc.data[0].to,
				errorDocumentText: null,
				page_number: page_number,
				total_page_number: total_page_number,
				author: author,
				filename: filename,
				file_name: file_name,
				filepath: filepath,
				category: category,
				comments: comments,
				content_status: content_status,
				identifier: identifier,
				keywords: keywords,
				language: language,
				title: title,
				version: version,
			})

			// documentContent.then(response => {
			//     let contentDoc = response.data;
			//     let datosGenerales=conceptDocs.data.filter(i => i['_id']['$oid']===idDocument);
			//     let subject="";
			//     let to="";
			//     let from="";
			//     let page_number="";
			//     let total_page_number="";
			//     let author="";
			//     let filename="";
			//     let file_name="";
			//     let file_path="";
			//     let category="";
			//           let comments="";
			//           let content_status="";
			//           let identifier="";
			//           let keywords="";
			//           let language="";
			//           let title="";
			//           let version="";
			//     if (datosGenerales.length>0){
			//       opcionesCampos.forEach(function(index){
			//         if (datosGenerales[0].hasOwnProperty(index)){
			//           eval(index + '=' + '`${datosGenerales[0][index]}`');
			//         }
			//       })
			//     }

			//     setContent({
			//         documentId: contentDoc.data[0]._id.$oid,
			//         documentText: contentDoc.data[0].content,
			//         documentSubject: subject,  //contentDoc.data[0].subject,
			//         documentFrom: from,  //contentDoc.data[0].from,
			//         documentTo: to,     //contentDoc.data[0].to,
			//         errorDocumentText: null,
			//         page_number: page_number,
			//         total_page_number: total_page_number,
			//         author: author,
			//         filename: filename,
			//         file_name: file_name,
			//         filepath: file_path,
			//         category: category,
			//                   comments: comments,
			//                   content_status: content_status,
			//                   identifier: identifier,
			//                   keywords: keywords,
			//                   language: language,
			//                   title: title,
			//                   version: version
			//     })
			// })
		} else {
			setContent({
				documentId: null,
				documentText: null,
				documentSubject: null,
				documentFrom: null,
				documentTo: null,
				errorDocumentText: true,
				page_number: null,
				total_page_number: null,
				author: null,
				filename: null,
				file_name: null,
				filepath: null,
			})
		}
	} catch (e) {
		//console.log(e);
	}

	return
}
